export const FEATURE_NAME = '@zerops/zef/progress';
